module.exports = __webpack_public_path__ + "img/Villars_logo.5237e814.png";